/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Meteorology18Inputs */

const en__field__enum_additionalstudyinterests_study_meteorology18 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Meteorology18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meteorology`)
};

const de__field__enum_additionalstudyinterests_study_meteorology18 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Meteorology18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meteorologie`)
};

/**
* | output |
* | --- |
* | "Meteorology" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Meteorology18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_meteorology18 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Meteorology18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Meteorology18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_meteorology18(inputs)
	return de__field__enum_additionalstudyinterests_study_meteorology18(inputs)
});
export { _field__enum_additionalstudyinterests_study_meteorology18 as "_field__enum_additionalStudyInterests_STUDY_METEOROLOGY" }